import React from "react";
import {
    List,
    Datagrid,
    Edit,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={
    {
        name: '',
        book_name: '',
        user_code: '',
        user_name: '',
        user_email: '',
        price: 0,
        quantity: 0,
        discount: 0,
        total: 0,
        delivery_name: '',
        delivery_phone: '',
        delivery_address: '',
        note: '',
        payment_method: '',
        f0_code: '',
        f0_name: '',
        f0_email: '',
        created_at: '',
    }
} selections={
    {status: 'book-order-status'}
}/>

const BookOrderFilter = (props) => (
    <Filter {...props}>
        <TextInput source="charge_code" label="Code" alwaysOn/>
    </Filter>
);

export const BookOrderList = props => (
    <List {...props} filters={<BookOrderFilter/>} filter={{is_published: true}}>
        <Datagrid>
            {/*<TextField source="id"/>*/}
            <TextField source="stt"/>
            <TextField source="created_at"/>
            <TextField source="code"/>
            <TextField source="book_name"/>
            <TextField source="user_code"/>
            <TextField source="user_name"/>
            <TextField source="user_email"/>
            <TextField source="price"/>
            <TextField source="quantity"/>
            <TextField source="total"/>
            <TextField source="discount"/>
            <TextField source="payment_method"/>
            <TextField source="f0_code"/>
            <TextField source="f0_name"/>
            <TextField source="f0_email"/>
            <TextField source="f0_commission"/>
            <TextField source="company_profit"/>
            <TextField source="status"/>
            <EditButton basePath="/book-order"/>
        </Datagrid>
    </List>
);

export const BookOrderEdit = props => (
    <Edit {...props}>
        {form}
    </Edit>
);
